import React, { useState, useEffect } from 'react';
import "./waywework.css";
import wework from "../../interior_assets/aboutus/waywework11.jpeg";
import Contactpopup from '../contact_popup/contactpopup';

function Waywework() {
  const [activeStep, setActiveStep] = useState(1);
  const [showpopup, setShowpopup] = useState(false);

  const openPopup = () => {
    setShowpopup(true);
  }

  const closePopup = () => {
    setShowpopup(false);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prevStep) => (prevStep === 6 ? 1 : prevStep + 1));
    }, 2000); // Change step every 2 seconds

    return () => clearInterval(interval); // Clear interval on component unmount
  }, []);

  const stepContent = [
    {
      label: "Consultation",
      description: "We begin by discussing your vision and requirements, either online or in person, to ensure we fully understand your needs."
    },
    {
      label: "Design",
      description: "Our team creates a custom interior design plan, including 3D renders and layout options, tailored to your preferences."
    },
    {
      label: "Budget",
      description: "We provide clear pricing and a well-defined scope of work to ensure the project stays within your budget and meets expectations."
    },
    {
        label:"Planning",
        description:" We source high-quality materials and carefully plan the project timeline to ensure smooth execution."
    },
    {
      label: "Execution",
      description: "Our skilled team manages the project, ensuring precise implementation with quality checks at every stage."
    },
    {
      label: "Handover",
      description: " Your completed space is delivered on time, with every detail perfected and your full satisfaction guaranteed."
    }
  ];

  return (
    <section className=" section-wework">
      <div className="container container-wework">
      

          {/* Content Section */}
          <div className="main-wework-section">
            <h2 className="heading-head">
              The Way We Work
            </h2>
            <p className="subHeading-para">
            Six simple steps to transform your space with ease.
            </p>

            <div className="div-weworksub">
              <ul className="wework-ul">
                <li className={activeStep === 1 ? "active-wework" : ""}>
                  <span>1</span>
                  <label>Consultation</label> 
                </li>
                <li className={activeStep === 2 ? "active-wework" : ""}>
                  <span>2</span><label>Design</label>
                </li>
                <li className={activeStep === 3 ? "active-wework" : ""}>
                  <span>3</span><label>Budget</label>
                </li>
                <li className={activeStep === 4 ? "active-wework" : ""}>
                  <span>4</span><label>Planning</label>
                </li>
                <li className={activeStep === 5 ? "active-wework" : ""}>
                  <span>5</span><label>Execution</label>
                </li>
                <li className={activeStep === 6 ? "active-wework" : ""}>
                  <span>6</span><label>Handover</label>
                </li>
              </ul>
            </div>

            {/* Only show content of the active step */}
            <div className="label-activestep">
              <label>{stepContent[activeStep - 1].label}</label>
              <span>{stepContent[activeStep - 1].description}</span>
            </div>
          
          </div>

          {/* Image Section */}
          <div className="img-section-wework">
            <figure>
              <img 
                alt="meet us" 
                loading="lazy" 
                width="474" 
                height="316" 
                decoding="async" 
                className="imgFluid" 
                style={{ color: "transparent" }} 
                src={wework} 
              />
            </figure>
          </div>
        

     
      </div>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"center", width:"100%",marginBottom:"50px"}}>
<button className="whyChooseus_whyChooseBtn__GTv3X btn btnPrimery mxAuto main-enquiry-button" 
                        style={{ background: "#e6c6c0", fontWeight: 500, color:"#cf5b55" }} onClick={openPopup} >
                    Book Free Consultation
                </button>
                </div>

                   {/* Conditionally render the Contactpopup */}
      {showpopup && <Contactpopup onClose={closePopup} />}
  
    </section>
  );
}

export default Waywework;
